import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DownloadSampleService } from '../Model/DownloadSample/download-sample.service';
import { ResignationReasonMasterFormComponent } from '../resignation-reason-master-form/resignation-reason-master-form.component';
import { ComboService } from '../Model/Combo/combo.service';

@Component({
  selector: 'app-resignation-reason-master',
  standalone: true,
  imports: [CommonModule, DataTablesModule, LoaderComponent],
  templateUrl: './resignation-reason-master.component.html',
  styleUrl: './resignation-reason-master.component.scss'
})
export class ResignationReasonMasterComponent {

  isDisabled: boolean = false;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  constructor(
    private modalService: NgbModal,
    private download: DownloadSampleService,
    private combo: ComboService,
  ) { }

  ngOnInit() {
    this.Comboload('SeparationReason');
   }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  TableData: any[] = [];

  dtoptions: DataTables.Settings = {
    pagingType: 'full_numbers',
    searching: true,
    pageLength: 10,
    lengthMenu: [5, 10, 25, 50, 100],
    processing: true,
    lengthChange: true,
    language: {
      searchPlaceholder: 'Search...',
    }
  };

  Comboload(Combotype: String) {
    this.combo.ComboLoad({
      'Combotype': Combotype,
      'IsReport': true
    }).subscribe({
      next: (response) => {
        if (Combotype == 'SeparationReason') {
          this.TableData = response.ComboLoad;
        }
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  addResignationReason(id: any, Name: any, Active: any) {
    const modalRef = this.modalService.open(ResignationReasonMasterFormComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      windowClass: 'confirmation-modal'
    })

    modalRef.componentInstance.SiteSubGroupMasterID = id;
    modalRef.componentInstance.SiteSubGroupName = Name;
    modalRef.componentInstance.IsActive = Active;

    modalRef.result.then((result: any) => {
      if (result) {

      }
    })
  }

  exportToExcel() {
    this.isDisabled = true;
    if (this.TableData.length > 0) {
      this.download.exportToExcel(this.TableData, "Resignation Reason Master");
      this.isDisabled = false
    }
    else {
      alert('No Data Found');
      this.isDisabled = false
    }
  }

}
